import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Area } from '../model/area';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class AreaService {

    constructor(private http: HttpClient) {
    }

    save(area: Area, timeStamp: string): Observable<any> {
        const url = environment.airUrl + '/execution/area/create';

        const headers = new HttpHeaders({
            timeStamp
        });

        return this.http.post(url, area, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    update(area: Area, timeStamp: string): Observable<any> {
        const url = environment.airUrl + `/execution/area/${area.id}`;

        const headers = new HttpHeaders({
            timeStamp
        });

        return this.http.put(url, area, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    delete(area: Area, timeStamp: string): Observable<any> {
        const url = environment.airUrl + `/execution/area/${area.id}`;

        const headers = new HttpHeaders({
            timeStamp
        });

        return this.http.delete(url, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

}
